import * as types from './constants';

// Get Sendbird Batch Message Info
export const getSendbirdBatchMessageInfoRequest = data => (
  { type: types.GET_SENDBIRD_BATCH_MESSAGE_INFO_REQUEST, payload: data }
);

export const getSendbirdBatchMessageInfoDone = data => (
  { type: types.GET_SENDBIRD_BATCH_MESSAGE_INFO_DONE, payload: data }
);

export const getSendbirdBatchMessageInfoFailed = errors => (
  { type: types.GET_SENDBIRD_BATCH_MESSAGE_INFO_FAILED, payload: errors }
);